module.exports = __webpack_public_path__ + "media/images/lb/325-9e07c461aa83c333099555d5b1f294b1.svg";